export class ConfirmPhoneRegistrationSubmit {
    constructor(optionalOptions = {}) {
        this._modalButton = document.querySelector('#modal-confirm-phone [data-action="submit"]');

        if (!this._modalButton) {
            this.destructor();
            return true;
        }

        this._form = document.querySelector('.registration-container--form')

        if (!this._form) {
            this.destructor();
            return true;
        }

        let thatForm = this._form

        this._modalButton.addEventListener("click", () => {
            window.closeAllModals()
            thatForm.submit();
        })
    }

    destructor() {
        this._modalButton = null;
    }
}

export default new ConfirmPhoneRegistrationSubmit();
